import { hasProfileCompleteCelebration, hasProfileCompleteFlowOrigin } from './celebration';
import {
    PROFILE_COMPLETE_FLOW_PET_KEY,
    PROFILE_COMPLETE_FLOW_USER_SCOPE_KEY,
    PROFILE_COMPLETE_NO_PET_SELECTED_KEY,
    PROFILE_COMPLETE_NOTIFICATIONS_SUBMITTED_KEY,
} from './constants';
import { safeGet, safeRemove, safeSet } from './safe-session-storage';

export type CompleteProfileFlowPet = {
    petId: number;
    petName: string;
    speciesId: number;
};

export function setProfileCompleteNoPetSelected(): void {
    safeSet(PROFILE_COMPLETE_NO_PET_SELECTED_KEY, 'true');
}

export function hasProfileCompleteNoPetSelected(): boolean {
    return safeGet(PROFILE_COMPLETE_NO_PET_SELECTED_KEY) === 'true';
}

export function clearProfileCompleteNoPetSelected(): void {
    safeRemove(PROFILE_COMPLETE_NO_PET_SELECTED_KEY);
}

export function setProfileCompleteNotificationsSubmitted(): void {
    safeSet(PROFILE_COMPLETE_NOTIFICATIONS_SUBMITTED_KEY, 'true');
}

export function hasProfileCompleteNotificationsSubmitted(): boolean {
    return safeGet(PROFILE_COMPLETE_NOTIFICATIONS_SUBMITTED_KEY) === 'true';
}

export function hasInProgressCompleteProfileFlow(): boolean {
    return hasProfileCompleteFlowOrigin() || hasProfileCompleteCelebration();
}

export function clearProfileCompleteNotificationsSubmitted(): void {
    safeRemove(PROFILE_COMPLETE_NOTIFICATIONS_SUBMITTED_KEY);
}

export function setProfileCompleteFlowPet(pet: CompleteProfileFlowPet): void {
    safeSet(PROFILE_COMPLETE_FLOW_PET_KEY, JSON.stringify(pet));
}

export function getProfileCompleteFlowPet(): CompleteProfileFlowPet | null {
    const value = safeGet(PROFILE_COMPLETE_FLOW_PET_KEY);
    if (!value) {
        return null;
    }

    try {
        return JSON.parse(value) as CompleteProfileFlowPet;
    } catch {
        return null;
    }
}

export function clearProfileCompleteFlowPet(): void {
    safeRemove(PROFILE_COMPLETE_FLOW_PET_KEY);
}

export function clearCompleteProfileFlowSession(): void {
    clearProfileCompleteFlowPet();
}

export function clearCompleteProfileFlowCompletionFlags(): void {
    clearProfileCompleteNoPetSelected();
    clearProfileCompleteNotificationsSubmitted();
    clearCompleteProfileFlowSession();
}

export function syncCompleteProfileFlowSessionUser(userScope: string | null): void {
    if (!userScope) {
        return;
    }

    const previousScope = safeGet(PROFILE_COMPLETE_FLOW_USER_SCOPE_KEY);
    if (previousScope === userScope) {
        return;
    }

    if (previousScope) {
        clearCompleteProfileFlowCompletionFlags();
    }

    safeSet(PROFILE_COMPLETE_FLOW_USER_SCOPE_KEY, userScope);
}
